function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var SvgAboutMe = function SvgAboutMe(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#415A6B"
    },
    d: "M247.467,199.467c0,69.333-30.933,117.333-69.333,117.333s-69.333-48-69.333-117.333 c0-49.067,30.933-62.933,69.333-62.933S247.467,150.4,247.467,199.467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7B64C"
    },
    d: "M132.267,273.067l-1.067,39.467c0,0-8.533,40.533,4.267,67.2c46.933-9.6,97.067-16,82.133-67.2 v-39.467L132.267,273.067L132.267,273.067z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CED6E0"
    },
    points: "222.933,512 265.6,368 158.933,368 108.8,354.133 110.933,512 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F3705A"
    },
    points: "202.667,512 187.733,406.4 162.133,406.4 147.2,512 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F05540"
    },
    points: "187.733,406.4 200.533,393.6 174.933,368 149.333,393.6 162.133,406.4 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3F3F3"
    },
    d: "M131.2,312.533c0,0-3.2,11.733,0,19.2c3.2,7.467,43.733,35.2,43.733,35.2l-37.333,38.4 l-24.533-49.067l7.467-27.733c1.067-4.267,3.2-8.533,5.333-11.733C128,315.733,130.133,313.6,131.2,312.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#344A5E"
    },
    d: "M134.4,512l-24.533-112l1.067-53.333l-73.6,34.133c-18.133,8.533-30.933,25.6-32,45.867L0,512H134.4z "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#415A6B"
    },
    points: "112,512 146.133,512 121.6,327.467 82.133,398.933 102.4,397.867 76.8,420.267 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3F3F3"
    },
    d: "M218.667,312.533c0,0,3.2,11.733,0,19.2s-43.733,35.2-43.733,35.2l37.333,37.333L236.8,355.2 l-7.467-27.733c-1.067-4.267-3.2-8.533-5.333-11.733C221.867,315.733,219.733,313.6,218.667,312.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#344A5E"
    },
    d: "M349.867,512l-6.4-85.333c-1.067-20.267-13.867-37.333-32-45.867l-73.6-34.133L238.933,400 l-23.467,112H349.867z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#415A6B"
    },
    points: "203.733,512 237.867,512 273.067,420.267 247.467,397.867 267.733,398.933 228.267,327.467  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1366 0.9906 -0.9906 0.1366 352.7408 106.5032)",
    style: {
      fill: "#FFD15C"
    },
    cx: 115.272,
    cy: 255.612,
    rx: 23.466,
    ry: 10.666
  }), /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.1366 -0.9906 0.9906 0.1366 -44.4396 458.9958)",
    style: {
      fill: "#FFD15C"
    },
    cx: 241.097,
    cy: 254.992,
    rx: 23.466,
    ry: 10.666
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFD15C"
    },
    d: "M186.667,170.667c-10.667,26.667-34.133,46.933-71.467,48C113.067,227.2,112,236.8,112,246.4 c0,52.267,27.733,93.867,61.867,93.867s61.867-42.667,61.867-93.867c0-18.133-3.2-34.133-8.533-48 C210.133,194.133,196.267,183.467,186.667,170.667z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8AD7F8"
    },
    d: "M512,117.333c0,65.067-56.533,117.333-125.867,117.333c-8.533,0-17.067-1.067-24.533-2.133 l-61.867,48v-77.867c-24.533-21.333-39.467-51.2-39.467-85.333C260.267,52.267,316.8,0,386.133,0S512,52.267,512,117.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M397.867,151.467h-24.533c0-3.2,0-5.333,0-6.4c0-7.467,1.067-13.867,4.267-19.2 c3.2-5.333,7.467-10.667,14.933-17.067c7.467-6.4,12.8-10.667,13.867-12.8c2.133-3.2,3.2-6.4,3.2-10.667c0-5.333-2.133-9.6-6.4-12.8 c-4.267-3.2-9.6-5.333-17.067-5.333c-6.4,0-12.8,2.133-17.067,5.333c-4.267,4.267-7.467,9.6-9.6,17.067l-24.533-3.2 C336,74.667,340.267,66.133,348.8,57.6c8.533-7.467,20.267-11.733,35.2-11.733c14.933,0,27.733,4.267,36.267,11.733 c8.533,7.467,13.867,17.067,13.867,27.733c0,5.333-2.133,11.733-5.333,17.067c-3.2,5.333-10.667,12.8-21.333,21.333 c-5.333,4.267-8.533,8.533-10.667,10.667C397.867,138.667,397.867,144,397.867,151.467z M373.333,173.867L373.333,173.867 c0-7.467,6.4-12.8,12.8-12.8l0,0c7.467,0,12.8,6.4,12.8,12.8l0,0c0,7.467-6.4,12.8-12.8,12.8l0,0 C379.733,186.667,373.333,181.333,373.333,173.867z"
  }), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAboutMe, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/about_me.afa013ae.svg";
export { ForwardRef as ReactComponent };